
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/shiva/power-of-the-mantra",
      function () {
        return require("private-next-pages/mahashivratri/shiva/power-of-the-mantra/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/shiva/power-of-the-mantra"])
      });
    }
  